import React, { Component } from 'react'
import { StyledSection } from './mTooltip.style'

import {
  TextColor,
  Richtext,
  Button,
  createTagOverride
} from '@volkswagen-onehub/components-core'

class Tooltip extends Component {
  state = {
    showTooltip: false
  }
  removeLastParagraph = text => {
    /* eslint-disable no-useless-escape */
    const regex = /<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>/
    const list = text.split(regex) // split on all p tags
    let para = []
    const markdown = {
      start: '',
      end: ''
    }
    // create a list from the actual text
    list.map(item => {
      if (item !== '') {
        para.push(item)
      }
      return null
    })

    if (para.length === 1) {
      // if the list only 1 item long, we need to find the closing tag, we know that its not a </p>
      const item = para[0]
      if (item.charAt(item.length - 1) === '>') {
        const obj = this.getClosingTag(item)
        markdown.end = obj.end
        para = [obj.start]
      }
    } else {
      // add the <p> tag back in, except to the last item - this is a glitch in Onehub
      // for some reason the last item on a Onehub Richtext component can't be a <p> tag!
      // it needs to be a plain String - otherwise Onehub creates a douplicate empty <p> tag!!
      for (var i = 0; i < para.length; i++) {
        const item = para[i]
        if (i < para.length - 1 && item.charAt(0) !== '<') {
          para[i] = `<p>${item}</p>`
        }
      }
    }

    markdown.start = para.join('')
    return markdown
  }

  getClosingTag = text => {
    let closingTagPos = 1
    for (var i = 1; i < text.length; i++) {
      if (text.charAt(text.length - i) === '<') {
        closingTagPos = i
        break
      }
    }
    return {
      start: text.substring(0, text.length - closingTagPos),
      end: text.substr(text.length - closingTagPos)
    }
  }

  render() {
    const { text, tooltipText, textAppearance } = this.props
    const markdown = this.removeLastParagraph(text)
    const svg =
      '<svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" role="img"><path d="M12 6.493c.442 0 .774.295.774.811s-.332.811-.774.811-.774-.295-.774-.811.332-.811.774-.811zM12.783 15.656v-5.649H9.414v1.33h2.039v4.319H8.419v1.33l6.967-.001v-1.33z"></path><path d="M12 2.33c5.603 0 9.67 4.067 9.67 9.67s-4.067 9.67-9.67 9.67S2.33 17.603 2.33 12 6.397 2.33 12 2.33M12 1C5.626 1 1 5.626 1 12s4.626 11 11 11 11-4.626 11-11S18.374 1 12 1z"></path></svg>'
    const linkCompleteOverride = createTagOverride(Button, {
      onClick: (e) => {
        this.setState(prevState => ({
          showTooltip: !prevState.showTooltip
        }))
      }
    })
    return (
      <StyledSection className="tooltip" text={textAppearance}>
        <Richtext
          markdown={markdown.start + '<a>' + svg + '</a>' + markdown.end}
          overrides={{ a: linkCompleteOverride }}
        />
        <div
          className={`additional-text${
            this.state.showTooltip ? ' additional-text--show' : ''
          }`}
        >
          <Richtext markdown={tooltipText} color={TextColor.inherit} />
        </div>
      </StyledSection>
    )
  }
}

export default Tooltip
